/* eslint-disable max-len */
import React, { useState } from 'react';
import {
  Box, Typography, AppBar, Divider, List, ListItem, ListItemButton, ListItemText, Toolbar, IconButton, Drawer, Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../images/Access2.png';
import logo1 from '../../images/Access1.png';

const drawerWidth = 240;
const navItems = ['Home', 'Services', 'Pricing', 'Features', 'Contact'];

const Nav = (props) => {
  // eslint-disable-next-line react/prop-types
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography sx={{ my: '2' }}>
        <img style={{ width: '180px', height: '70px' }} src={logo1} alt="logo" />
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', width: '100%', padding: '37px 100px' }}>
      <AppBar component="nav">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            ACCESSIN MEDIA
          </Typography> */}
          <Typography sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
            <img style={{ width: '180px', height: '70px' }} src={logo} alt="logo" />
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => (
              <Button component="a" href={`#${item.toLowerCase()}`} key={item} sx={{ color: '#fff' }}>
                {item}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

export default Nav;
